import script from "./Asct.vue?vue&type=script&setup=true&lang=js"
export * from "./Asct.vue?vue&type=script&setup=true&lang=js"

export default script